import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-faq-icon',
  templateUrl: './lib-faq-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibFaqIconComponent {}
